/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Upper_ThirdInputs */

const en_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upper Third`)
};

const fr_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiers supérieur`)
};

const de_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberes Drittel`)
};

const it_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terzo superiore`)
};

const ru_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верхняя треть`)
};

const es_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tercio superior`)
};

const zh_cn2_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上三分之一`)
};

const ja_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上部3分の1`)
};

const hi_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऊपरी तीसरा`)
};

const pt_pt2_ocr_crop_upper_third = /** @type {(inputs: Ocr_Crop_Upper_ThirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terço superior`)
};

/**
* | output |
* | --- |
* | "Upper Third" |
*
* @param {Ocr_Crop_Upper_ThirdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_upper_third = /** @type {((inputs?: Ocr_Crop_Upper_ThirdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Upper_ThirdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_upper_third(inputs)
	if (locale === "de") return de_ocr_crop_upper_third(inputs)
	if (locale === "it") return it_ocr_crop_upper_third(inputs)
	if (locale === "ru") return ru_ocr_crop_upper_third(inputs)
	if (locale === "es") return es_ocr_crop_upper_third(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_upper_third(inputs)
	if (locale === "ja") return ja_ocr_crop_upper_third(inputs)
	if (locale === "hi") return hi_ocr_crop_upper_third(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_upper_third(inputs)
	return en_ocr_crop_upper_third(inputs)
});